/**
 * Shared header constants.
 */

/** Overlay: one constant for both panel width (span of main grid) and content grid columns. Shared here to avoid circular import (MenuOverlay ↔ NavigationSubmenuSection). */
export const OVERLAY_GRID_COLUMNS = 10;
